export enum TableDefaults {
  PAGESIZE = 10,
}
